export function withFallback(value: unknown): string {
    if (
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim() === "") ||
      (typeof value === "number" && isNaN(value))
    ) {
      return "-";
    }
  
    return String(value);
  }
  
  export function formatDate(date: string | number | Date | null | undefined): string {
    try {
      if (!date) return "-";
      const d = new Date(date);
      if (isNaN(d.getTime())) return "-";
      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch {
      return "-";
    }
  }
  
  export function formatCamelCase(text: string): string {
    return text
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^./, (str) => str.toUpperCase());
  }

  export function formatTerm(term: unknown, unit: unknown): string {
    const t = withFallback(term);
    const u = withFallback(unit);
  
    // If both are fallback dashes, just return one
    if (t === "-" && u === "-") return "-";
  
    // If only one has value, return just that one
    if (t === "-") return u;
    if (u === "-") return t;
  
    // If both exist
    return `${t} ${u}`;
  }

  export const formatLabelWithParentheses = (main?: string, sub?: string): string => {
    const mainSafe = withFallback(main);
    const subSafe = withFallback(sub);
  
    if (mainSafe === "-" && subSafe === "-") return "-";
    if (mainSafe === "-") return `(${subSafe})`;
    if (subSafe === "-") return mainSafe;
    return `${mainSafe} (${subSafe})`;
  };
  
  
  